export const attrToProp = (name, value) => {
    try {
        if (name.match(/^eval\S/)) {
            const nameStr = name.replace(/^eval(\S)/, (c, g) => {
                return g.toLowerCase();
            });
            return { [nameStr]: value ? eval(value) : value };
        }
        return { [name]: value };
    }
    catch (e) {
        console.error(e);
        return {};
    }
};
